module.exports = __webpack_public_path__ + "static/img/硕士_2023_吴佳盈_wujiaying1201@163.com.11479e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/members/硕士_2023_吴佳盈_wujiaying1201@163.com.jpg
// module id = pecJ
// module chunks = 6